import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const reorderSavedView: YJSChangeHandler<
  DatabaseChangeType.REORDER_SAVED_VIEW
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.reorderView(change.viewId, change.newIndex);
  });
};
